module.exports = __webpack_public_path__ + "img/PCN.603fea09.svg";